import { render, staticRenderFns } from "./BblObservasiGrid.vue?vue&type=template&id=c03ad52c&scoped=true&"
import script from "./BblObservasiGrid.vue?vue&type=script&lang=ts&"
export * from "./BblObservasiGrid.vue?vue&type=script&lang=ts&"
import style0 from "./BblObservasiGrid.vue?vue&type=style&index=0&id=c03ad52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03ad52c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSimpleTable,VTextField})
